export const NOTE = { value: "NOTE", key: "members.followUps.types.note" };
export const INCIDENT = {
  value: "INCIDENT",
  key: "members.followUps.types.incidentFollowUp",
};
export const SPECIAL_MODIFICATION = {
  value: "SPECIAL_MODIFICATION",
  key: "members.followUps.types.specialModification",
};
export const PASSWORD_MANAGEMENT = {
  value: "PASSWORD_MANAGEMENT",
  key: "members.followUps.types.passwordManagement",
};

export default [NOTE, INCIDENT, SPECIAL_MODIFICATION, PASSWORD_MANAGEMENT];

export const ENUM_DICT = {
  NOTE,
  INCIDENT,
  SPECIAL_MODIFICATION,
  PASSWORD_MANAGEMENT,
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/enums/followUpTypes.js